import PriceSelect from "components/common/PriceSelect";
import ProductSelect from "components/common/ProductSelect";
import { UnitPriceType } from "enums/UnitPriceType";
import QuoteProduct from "interfaces/QuoteProduct";
import QuoteProductGroup from "interfaces/QuoteProductGroup";
import * as numeral from "numeral";
import * as React from "react";
import {
    DragDropContext, Draggable, Droppable
} from "react-beautiful-dnd";
import { Option } from "react-select";
import MaskedInput from "react-text-mask";
import createNumberMask from "utils/createNumberMask";
import "./Step3.css";

interface Props {
    onSubmit: Function;
    onCancel: Function;
    isNewQuote: boolean;
    isDraft: boolean;
    salesTaxRate?: number;
    productGroups: QuoteProductGroup[];
}

interface State {
    productGroups: QuoteProductGroup<EditableQuoteProduct>[];
    subTotal: number;
    salesTax: number;
    grandTotal: number;
}

interface EditableQuoteProduct extends QuoteProduct {
    isEditing: boolean;
    kitChildren?: QuoteProduct[];
    isKitChild?: boolean;
    parentProductId?: number;
}

export default class Step3 extends React.Component<Props, State> {
    private categoryNameInputs: HTMLTextAreaElement[];
    private unitPriceTypeNames: string[];

    public constructor(props: Props) {
        super(props);

        this.unitPriceTypeNames = ["", "TBD", "NC", "Not Avail", "No Bid", "Note"];

        this.state = {
            productGroups: [],
            subTotal: 0,
            salesTax: 0,
            grandTotal: 0,
        };

        this.categoryNameInputs = [];

        this.handleHeaderNameChanged = this.handleHeaderNameChanged.bind(this);
        this.handleAddCategoryClicked = this.handleAddCategoryClicked.bind(this);
        this.handleAddProduct = this.handleAddProduct.bind(this);
        this.handleEditProductClicked = this.handleEditProductClicked.bind(this);
        this.handleRemoveProduct = this.handleRemoveProduct.bind(this);
        this.handleRemoveHeader = this.handleRemoveHeader.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitAsDraft = this.handleSubmitAsDraft.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
    }

    public render() {
        return (
            <div className="card card--datatables mb-0">
                <div className="card-block">
                    <form>
                        <h2 className="card__title">Material Details</h2>
                        <DragDropContext onDragEnd={this.handleDragEnd}>
                            {this.state.productGroups.map((item, groupIndex) => (
                                <Droppable droppableId={groupIndex.toString()} type="header">
                                    {(provided1: { innerRef: React.LegacyRef<HTMLDivElement> | undefined; droppableProps: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>; }, snapshot1: any) => (
                                        <div
                                            key={groupIndex}
                                            ref={provided1.innerRef}
                                            {...provided1.droppableProps}
                                        >
                                            <div className="row">
                                                <Draggable
                                                    key={`header-${groupIndex}`}
                                                    draggableId={`header-${groupIndex}`}
                                                    index={groupIndex}
                                                >
                                                    {(provided1: { innerRef: React.LegacyRef<HTMLDivElement> | undefined; draggableProps: any; dragHandleProps: any; }, snapshot1: any) => (
                                                        <div
                                                            className="col-sm-12 quote-product-header"
                                                            ref={provided1.innerRef}
                                                            {...(provided1.draggableProps as any)}
                                                        >
                                                            <i
                                                                className="icon-drag-handle btn-drag"
                                                                {...(provided1.dragHandleProps as any)}
                                                            ></i>
                                                            <textarea
                                                                name={`categoryName[${groupIndex}]`}
                                                                className="form-control"
                                                                placeholder="Header Name"
                                                                value={item.name}
                                                                onChange={this.handleHeaderNameChanged}
                                                                ref={(x) =>
                                                                    (this.categoryNameInputs[groupIndex] = x!)
                                                                }
                                                                data-index={groupIndex}
                                                            />
                                                            <a
                                                                href="#"
                                                                className="btn-delete"
                                                                onClick={(event) =>
                                                                    this.handleRemoveHeader(event, groupIndex)
                                                                }
                                                            >
                                                                <i className="icon-delete1"></i>
                                                            </a>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            </div>
                                            <table className="table table-responsive tblQuote">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "8%" }}>Quantity</th>
                                                        <th style={{ width: "16%" }}>UM</th>
                                                        <th style={{ width: "25%" }}>Product</th>
                                                        <th style={{ width: "17%" }}>Notes</th>
                                                        <th style={{ width: "15%" }}>Price Type</th>
                                                        <th style={{ width: "35%" }}>Price</th>
                                                        <th style={{ width: "8%" }}>Amount</th>
                                                        <th style={{ width: "4%" }}></th>
                                                    </tr>
                                                </thead>
                                                <Droppable
                                                    droppableId={groupIndex.toString()}
                                                    type="product"
                                                >
                                                    {(provided: { innerRef: React.LegacyRef<HTMLTableSectionElement> | undefined; droppableProps: JSX.IntrinsicAttributes & React.ClassAttributes<HTMLTableSectionElement> & React.HTMLAttributes<HTMLTableSectionElement>; }, snapshot: any) => (
                                                        <tbody
                                                            ref={provided.innerRef}
                                                            {...provided.droppableProps}
                                                        >
                                                            {item.products.map((item, productIndex) => (
                                                                <Draggable
                                                                    key={`product-${groupIndex}-${productIndex}`}
                                                                    draggableId={`product-${groupIndex}-${productIndex}`}
                                                                    index={productIndex}
                                                                >
                                                                    {(provided: { innerRef: React.LegacyRef<HTMLTableRowElement> | undefined; draggableProps: any; dragHandleProps: any; }, snapshot: any) =>
                                                                        item.isEditing ? (
                                                                            <tr
                                                                                key={groupIndex + "," + productIndex}
                                                                                className="sortable-table-row quote-edit-product-row"
                                                                                ref={provided.innerRef}
                                                                                {...(provided.draggableProps as any)}
                                                                                {...(provided.dragHandleProps as any)}
                                                                            >
                                                                                <EditProductRow
                                                                                    data={item}
                                                                                    onSubmit={(e: any) =>
                                                                                        this.handleEditProduct(
                                                                                            e,
                                                                                            groupIndex,
                                                                                            productIndex
                                                                                        )
                                                                                    }
                                                                                    onKitChildrenAdd={(kitChildren: EditableQuoteProduct[]) =>
                                                                                        this.addKitChildrenToGroup(kitChildren, groupIndex)
                                                                                    }
                                                                                />
                                                                            </tr>
                                                                        ) : (
                                                                            <tr
                                                                                key={groupIndex + "," + productIndex}
                                                                                className="sortable-table-row"
                                                                                ref={provided.innerRef}
                                                                                {...(provided.draggableProps as any)}
                                                                                {...(provided.dragHandleProps as any)}
                                                                            >
                                                                                <td style={{ width: "8%" }}>
                                                                                    {item.quantity}
                                                                                </td>
                                                                                <td style={{ width: "16%" }}>
                                                                                    {item.unitMeasurement}
                                                                                </td>
                                                                                <td style={{ width: "28%" }}>
                                                                                    {item.productName}
                                                                                </td>
                                                                                <td style={{ width: "20%" }}>
                                                                                    {item.notes}
                                                                                </td>
                                                                                <td style={{ width: "15%" }}>
                                                                                    {item.unitPriceTypeId &&
                                                                                        this.unitPriceTypeNames[
                                                                                        item.unitPriceTypeId
                                                                                        ]}
                                                                                </td>
                                                                                <td
                                                                                    className="text-right"
                                                                                    style={{ width: "8%" }}
                                                                                >
                                                                                    {numeral(item.price).format(
                                                                                        "$0,0.00"
                                                                                    )}
                                                                                </td>
                                                                                <td
                                                                                    className="text-right"
                                                                                    style={{ width: "8%" }}
                                                                                >
                                                                                    {numeral(item.amount).format(
                                                                                        "$0,0.00"
                                                                                    )}
                                                                                </td>
                                                                                <td
                                                                                    className="text-center"
                                                                                    style={{ width: "4%" }}
                                                                                >
                                                                                    <a
                                                                                        href="#"
                                                                                        className="btn-edit"
                                                                                        onClick={(event) =>
                                                                                            this.handleEditProductClicked(
                                                                                                event,
                                                                                                groupIndex,
                                                                                                productIndex
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <i className="icon-edit1"></i>
                                                                                    </a>
                                                                                    <a
                                                                                        href="#"
                                                                                        className="btn-delete"
                                                                                        onClick={(event) =>
                                                                                            this.handleRemoveProduct(
                                                                                                event,
                                                                                                groupIndex,
                                                                                                productIndex
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        <i className="icon-delete1"></i>
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </Draggable>
                                                            ))}
                                                            <Draggable
                                                                key={`add-product-${groupIndex}`}
                                                                draggableId={`add-product-${groupIndex}`}
                                                                index={item.products.length}
                                                                isDragDisabled={true}
                                                            >
                                                                {(provided: { innerRef: React.LegacyRef<HTMLTableRowElement> | undefined; draggableProps: any; dragHandleProps: any; }, snapshot: any) => (
                                                                    <tr
                                                                        key={"add-product-" + groupIndex}
                                                                        className="sortable-table-row quote-add-product-row"
                                                                        ref={provided.innerRef}
                                                                        {...(provided.draggableProps as any)}
                                                                        {...(provided.dragHandleProps as any)}
                                                                    >
                                                                        <AddProductRow
                                                                            onSubmit={(e: any) =>
                                                                                this.handleAddProduct(e, groupIndex)
                                                                            }
                                                                            onKitChildrenAdd={(kitChildren: EditableQuoteProduct[]) =>
                                                                                this.addKitChildrenToGroup(kitChildren, groupIndex)
                                                                            }
                                                                        />
                                                                    </tr>
                                                                )}
                                                            </Draggable>
                                                        </tbody>
                                                    )}
                                                </Droppable>
                                                <tfoot>
                                                    <tr className="sub-total">
                                                        <td colSpan={7}>Subtotal</td>
                                                        <td colSpan={2} className="text-right">
                                                            {numeral(item.subTotal).format("$0,0.00")}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    )}
                                </Droppable>
                            ))}
                        </DragDropContext>
                        <div className="button-actions add-header-actions">
                            <input
                                type="button"
                                className="btn btn-primary"
                                value="Add Another Header"
                                onClick={this.handleAddCategoryClicked}
                            />
                        </div>
                        <br />
                        <div className="grand-total-box">
                            {this.props.salesTaxRate !== undefined && (
                                <div className="sales-tax2">
                                    <span>
                                        Sales Tax (
                                        {numeral(this.props.salesTaxRate!).format("0.[0000]%")})
                                    </span>
                                    <span>{numeral(this.state.salesTax).format("$0,0.00")}</span>
                                </div>
                            )}
                            <div className="grand-total2">
                                <span>Grand Total</span>
                                <span>{numeral(this.state.grandTotal).format("$0,0.00")}</span>
                            </div>
                        </div>
                        <div className="button-actions text-center">
                            <button
                                className="btn btn-primary"
                                onClick={(event) => this.handleSubmit(event, 2)}
                            >
                                Previous
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={(event) => this.handleSubmit(event, 4)}
                            >
                                Next
                            </button>
                            {(this.props.isNewQuote || this.props.isDraft) && (
                                <button
                                    className="btn btn-primary"
                                    onClick={this.handleSubmitAsDraft}
                                >
                                    Save as Draft
                                </button>
                            )}
                            <button className="btn-link" onClick={this.handleCancel}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    public componentDidMount() {
        let subTotal: number;
        let salesTax: number;
        let grandTotal: number;

        let categories = this.props.productGroups as QuoteProductGroup<EditableQuoteProduct>[];

        if (categories.length === 0) {
            categories.push({
                name: "",
                products: [],
                subTotal: 0,
            });

            subTotal = 0;
            salesTax = 0;
            grandTotal = 0;
        } else {
            subTotal = categories.reduce(
                (total, category) => total + category.subTotal,
                0
            );
            salesTax =
                this.props.salesTaxRate != null
                    ? subTotal * this.props.salesTaxRate!
                    : 0;
            grandTotal = subTotal + salesTax;
        }

        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    public componentDidUpdate() {
        for (var i = 0; i < this.state.productGroups.length; i++) {
            this.categoryNameInputs[i].style.height = "0px";
            this.categoryNameInputs[i].style.height =
                this.categoryNameInputs[i].scrollHeight + "px";
        }
    }

    private handleSubmit(
        event: React.MouseEvent<HTMLButtonElement>,
        nextStepNumber: number
    ) {
        event.preventDefault();

        let data = {
            categories: this.state.productGroups,
            nextStepNumber: nextStepNumber,
        };

        this.props.onSubmit(data);
    }

    private handleSubmitAsDraft(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        let data = {
            categories: this.state.productGroups,
            saveAsDraft: true,
        };

        for (let i = 0; i < this.categoryNameInputs.length; i++) {
            data.categories[i].name = this.categoryNameInputs[i].value;
        }

        this.props.onSubmit(data);
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private handleAddCategoryClicked() {
        let categories = this.state.productGroups;
        categories.push({
            name: "",
            products: [],
            subTotal: 0,
        });
        this.setState({
            productGroups: categories,
        });
    }

    private handleAddProduct(data: EditableQuoteProduct, groupIndex: number) {
        data.isEditing = false;

        let categories = this.state.productGroups;

        categories[groupIndex].products.push(data);
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.salesTaxRate !== undefined
                ? subTotal * this.props.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleEditProductClicked(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number,
        productIndex: number
    ) {
        e.preventDefault();

        let categories = this.state.productGroups;
        categories[groupIndex].products[productIndex].isEditing = true;

        this.setState({
            productGroups: categories,
        });
    }

    private handleEditProduct(
        data: EditableQuoteProduct,
        groupIndex: number,
        productIndex: number
    ) {
        data.isEditing = false;
        let categories = this.state.productGroups;
        categories[groupIndex].products[productIndex] = data;
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.salesTaxRate !== undefined
                ? subTotal * this.props.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleRemoveProduct(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number,
        productIndex: number
    ) {
        e.preventDefault();

        let categories = this.state.productGroups;
        categories[groupIndex].products.splice(productIndex, 1);
        categories[groupIndex].subTotal = categories[groupIndex].products.reduce(
            (total, product) => total + product.amount,
            0
        );
        let subTotal = categories.reduce(
            (total, category) => total + category.subTotal,
            0
        );
        let salesTax =
            this.props.salesTaxRate !== undefined
                ? subTotal * this.props.salesTaxRate!
                : 0;
        let grandTotal = subTotal + salesTax;
        this.setState({
            productGroups: categories,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleHeaderNameChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.state.productGroups[
            parseInt(event.currentTarget.dataset.index!, 10)
        ].name = event.currentTarget.value;
        this.setState({
            productGroups: this.state.productGroups,
        });

        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handleRemoveHeader(
        e: React.SyntheticEvent<HTMLAnchorElement>,
        groupIndex: number
    ) {
        e.preventDefault();

        const productGroups = this.state.productGroups;
        productGroups.splice(groupIndex, 1);
        this.categoryNameInputs.splice(groupIndex, 1);

        let subTotal: number;
        let salesTax: number;
        let grandTotal: number;

        if (productGroups.length === 0) {
            productGroups.push({
                name: "",
                products: [],
                subTotal: 0,
            });

            subTotal = 0;
            salesTax = 0;
            grandTotal = 0;
        } else {
            subTotal = productGroups.reduce(
                (total, group) => total + group.subTotal,
                0
            );
            salesTax =
                this.props.salesTaxRate !== undefined
                    ? subTotal * this.props.salesTaxRate!
                    : 0;
            grandTotal = subTotal + salesTax;
        }

        this.setState({
            productGroups: productGroups,
            subTotal: subTotal,
            salesTax: salesTax,
            grandTotal: grandTotal,
        });
    }

    private handleDragEnd(result: any, provided: any) {
        if (!result.destination) {
            return;
        }

        if (result.draggableId.indexOf("header-") === 0) {
            if (result.source.droppableId === result.destination.droppableId) {
                return;
            }

            const sourceGroupIndex = parseInt(result.source.droppableId, 10);
            const destinationGroupIndex = parseInt(
                result.destination.droppableId,
                10
            );
            const productGroups = this.reorder(
                this.state.productGroups,
                sourceGroupIndex,
                destinationGroupIndex
            );
            this.setState({
                productGroups: productGroups,
            });
        } else if (result.draggableId.indexOf("product-") === 0) {
            if (result.source.droppableId === result.destination.droppableId) {
                // Reordering within the same list
                const groupIndex = parseInt(result.source.droppableId, 10);
                const products = this.reorder(
                    this.state.productGroups[groupIndex].products,
                    result.source.index,
                    result.destination.index
                );
                this.state.productGroups[groupIndex].products = products;
                this.setState({
                    productGroups: this.state.productGroups,
                });
            } else {
                // Item is being moved to a different list
                const sourceGroupIndex = parseInt(result.source.droppableId, 10);
                const destinationGroupIndex = parseInt(
                    result.destination.droppableId,
                    10
                );
                const newArrays = this.move(
                    this.state.productGroups[sourceGroupIndex].products,
                    result.source.index,
                    this.state.productGroups[destinationGroupIndex].products,
                    result.destination.index
                );

                this.state.productGroups[sourceGroupIndex].products = newArrays.source;
                this.state.productGroups[sourceGroupIndex].subTotal =
                    newArrays.source.reduce(
                        (total, product) => total + product.amount,
                        0
                    );
                this.state.productGroups[destinationGroupIndex].products =
                    newArrays.destination;
                this.state.productGroups[destinationGroupIndex].subTotal =
                    newArrays.destination.reduce(
                        (total, product) => total + product.amount,
                        0
                    );

                this.setState({
                    productGroups: this.state.productGroups,
                });
            }
        }
    }

    private reorder<T>(list: T[], startIndex: number, endIndex: number) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    private move<T>(
        source: T[],
        sourceIndex: number,
        destination: T[],
        destinationIndex: number
    ) {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(sourceIndex, 1);

        destClone.splice(destinationIndex, 0, removed);

        return {
            source: sourceClone,
            destination: destClone,
        };
    }

    private addKitChildrenToGroup(kitChildren: EditableQuoteProduct[], groupIndex: number) {
        const categories = [...this.state.productGroups];
        const group = categories[groupIndex];

        // Remove the AddProductRow if it was added as an empty entry
        //const lastItem = group.products[group.products.length - 1];
        //if (lastItem?.isEditing && !lastItem.productName && !lastItem.productId) {
        //    console.log("Removing last item:", lastItem);
        //    group.products.pop();
        //}
        group.products = group.products.filter(
            p => !(p.isEditing && !p.productName && !p.productId)
        );
        // Append the kit children to the product list
        kitChildren.forEach(child => {
            child.isEditing = true;
            child.amount = child.quantity * child.price;
            child.totalCost = 0;
        });

        group.products.push(...kitChildren);

        group.subTotal = group.products.reduce((sum, p) => sum + p.amount, 0);

        const subTotal = categories.reduce((sum, g) => sum + g.subTotal, 0);
        const salesTax = this.props.salesTaxRate ? subTotal * this.props.salesTaxRate : 0;
        const grandTotal = subTotal + salesTax;

        this.setState({
            productGroups: categories,
            subTotal,
            salesTax,
            grandTotal,
        });
    }

}

interface AddProductRowProps {
    onSubmit: Function;
    onKitChildrenAdd: Function;
}

interface AddProductRowState extends QuoteProduct {
    maskedQuantity: string;
    maskedPrice: string;
}

class AddProductRow extends React.Component<
    AddProductRowProps,
    AddProductRowState
> {
    private quantityInputRef: React.RefObject<HTMLInputElement>;
    private umInputRef: React.RefObject<HTMLInputElement>;
    private productSelectRef: React.RefObject<ProductSelect>;
    private notesInputRef: React.RefObject<HTMLTextAreaElement>;
    private unitPriceTypeSelectRef: React.RefObject<HTMLSelectElement>;
    private priceSelectRef: React.RefObject<PriceSelect>;
    private addButtonRef: React.RefObject<HTMLButtonElement>;

    public constructor(props: AddProductRowProps) {
        super(props);

        this.state = {
            maskedQuantity: "",
            quantity: 0,
            unitMeasurement: "",
            productName: "",
            price: 0,
            maskedPrice: "",
            amount: 0,
            productId: -1,
            cost: 0,
            totalCost: 0,
        };

        this.quantityInputRef = React.createRef();
        this.umInputRef = React.createRef();
        this.productSelectRef = React.createRef();
        this.notesInputRef = React.createRef();
        this.unitPriceTypeSelectRef = React.createRef();
        this.priceSelectRef = React.createRef();
        this.addButtonRef = React.createRef();

        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleQuantityChanged = this.handleQuantityChanged.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handlePriceTypeChanged = this.handlePriceTypeChanged.bind(this);
        this.handlePriceChanged = this.handlePriceChanged.bind(this);
        this.handleQuantityOrPriceChanged =
            this.handleQuantityOrPriceChanged.bind(this);
        this.handleNotesChanged = this.handleNotesChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePriceKeyDown = this.handlePriceKeyDown.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return (
            <>
                <td>
                    <input
                        type="number"
                        step="any"
                        name="quantity"
                        className="form-control"
                        onChange={this.handleQuantityChanged}
                        value={this.state.maskedQuantity}
                        ref={this.quantityInputRef}
                    />
                </td>
                <td>
                    <input
                        type="text"
                        name="unitMeasurement"
                        className="form-control"
                        onChange={this.handleInputChanged}
                        value={this.state.unitMeasurement}
                        ref={this.umInputRef}
                    />
                </td>
                <td>
                    <ProductSelect
                        onItemSelect={this.handleProductSelect}
                        ref={this.productSelectRef}
                    />
                </td>
                <td>
                    <textarea
                        name="notes"
                        className="form-control"
                        onChange={this.handleNotesChanged}
                        value={this.state.notes}
                        ref={this.notesInputRef}
                    />
                </td>
                <td>
                    <select
                        className="form-control"
                        onChange={this.handlePriceTypeChanged}
                        value={this.state.unitPriceTypeId}
                        ref={this.unitPriceTypeSelectRef}
                    >
                        <option value="">--</option>
                        <option value={UnitPriceType.TBD}>TBD</option>
                        <option value={UnitPriceType.NC}>NC</option>
                        <option value={UnitPriceType.NotAvail}>Not Avail</option>
                        <option value={UnitPriceType.NoBid}>No Bid</option>
                        <option value={UnitPriceType.NotMade}>Not Made</option>
                        <option value={UnitPriceType.Note}>Note</option>
                    </select>
                </td>
                <td onKeyDown={this.handlePriceKeyDown}>
                    <PriceSelect
                        productId={this.state.productId}
                        ref={this.priceSelectRef}
                        onItemSelect={this.handlePriceChanged}
                        onInputChange={this.handlePriceChanged}
                    />
                </td>
                <td className="text-right">
                    {this.state.amount !== undefined &&
                        numeral(this.state.amount).format("$0,0.00")}
                </td>
                <td>
                    <button
                        type="button"
                        className="form-control btn btn-primary"
                        onClick={this.handleSubmit}
                        ref={this.addButtonRef}
                    >
                        Add
                    </button>
                </td>
            </>
        );
    }

    private handleInputChanged(
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleQuantityChanged(event: React.FormEvent<HTMLInputElement>) {
        const maskedValue = event.currentTarget.value;
        const value = parseFloat(maskedValue) || 0;

        this.setState({
            quantity: value,
            maskedQuantity: maskedValue,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handlePriceTypeChanged(event: React.FormEvent<HTMLSelectElement>) {
        var unitPriceTypeId = parseInt(event.currentTarget.value, 10) || undefined;

        this.setState({
            unitPriceTypeId: unitPriceTypeId,
        });
    }

    private handlePriceChanged(inputPrice: string) {
        const value = parseFloat(inputPrice) || 0;

        this.setState({
            price: value,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handleQuantityOrPriceChanged() {
        this.setState((prevState) => ({
            amount: prevState.quantity * prevState.price,
        }));
    }

    //private async handleProductSelect(value: Option | null) {
    //    if (value === null) {
    //        this.setState({
    //            productId: undefined,
    //            unitMeasurement: undefined,
    //            productName: undefined,
    //        });
    //    } else {
    //        this.setState({
    //            productId: value!.value as number,
    //            unitMeasurement: value!.unitMeasurement as string | undefined,
    //            productName: value!.label as string,
    //        });
    //    }
    //}

    private async handleProductSelect(value: Option | null) {

        if (!value) {
            this.setState({
                productId: undefined,
                unitMeasurement: undefined,
                productName: undefined,
            });
            return;
        }

        // Set the parent info in case it's not a kit
        const updatedState = {
            productId: value!.value as number,
            unitMeasurement: value!.unitMeasurement as string | undefined,
            productName: value!.label as string,
        };

        // If it's a kit with children, send them to the parent
        if (value.kitChildren && Array.isArray(value.kitChildren)) {
            // Use the user-entered quantity to multiply with each kit child's quantity
            const userEnteredQuantity = this.state.quantity || 1;
            const kitChildren = value.kitChildren.map((child: any) => {
                const childQuantity = (child.quantity || 1) * userEnteredQuantity;
                return {
                    productId: child.id,
                    productName: child.name,
                    unitMeasurement: child.unitMeasurement,
                    quantity: childQuantity,
                    price: child.price || 0,
                    amount: childQuantity * (child.price || 0),
                    isKitChild: true,
                    parentProductId: value.value,
                };
            });

            this.props.onKitChildrenAdd?.(kitChildren); // new callback

            // Reset the quantity input after adding kit children
            this.setState({
                maskedQuantity: "",
                quantity: 0,
            });

            return;

        } else {
            this.setState(updatedState);
        }
    }

    private handleNotesChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.handleInputChanged(event);
        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handlePriceKeyDown(event: React.KeyboardEvent<HTMLTableCellElement>) {
        if (event.key === "Tab" && !event.shiftKey) {
            event.preventDefault();
            this.addButtonRef.current?.focus();
        }
    }

    private handleSubmit() {
        let data = {
            productId: this.state.productId,
            quantity: this.state.quantity,
            unitMeasurement: this.state.unitMeasurement,
            productName: this.state.productName,
            notes: this.state.notes,
            unitPriceTypeId: this.state.unitPriceTypeId,
            price: this.state.price,
            amount: this.state.amount,
        };

        this.props.onSubmit(data);

        this.productSelectRef.current!.value = undefined;
        this.notesInputRef.current!.value = "";
        this.unitPriceTypeSelectRef.current!.value = "";
        this.priceSelectRef.current?.clearValue();

        this.setState({
            productId: undefined,
            maskedQuantity: "",
            quantity: 0,
            unitMeasurement: "",
            productName: "",
            notes: undefined,
            unitPriceTypeId: undefined,
            price: 0,
            maskedPrice: "",
            amount: 0,
        });

        this.notesInputRef.current!.style.height = "0px";
        this.notesInputRef.current!.style.height =
            this.notesInputRef.current!.scrollHeight + "px";

        (this.quantityInputRef.current! as any).focus();
    }
}

interface EditProductRowProps {
    data: EditableQuoteProduct;
    onSubmit: Function;
    onKitChildrenAdd: Function;
}

class EditProductRow extends React.Component<
    EditProductRowProps,
    AddProductRowState
> {
    private quantityInputRef: React.RefObject<HTMLInputElement>;
    private productSelectRef: React.RefObject<ProductSelect>;
    private notesInputRef: React.RefObject<HTMLTextAreaElement>;
    private priceInputRef: React.RefObject<MaskedInput>;
    private priceSelectRef: React.RefObject<PriceSelect>;
    private updateButtonRef: React.RefObject<HTMLButtonElement>;

    public constructor(props: EditProductRowProps) {
        super(props);

        this.state = {
            productId: props.data.productId,
            maskedQuantity: props.data.quantity.toString(),
            quantity: props.data.quantity,
            unitMeasurement: props.data.unitMeasurement,
            productName: props.data.productName,
            notes: props.data.notes,
            price: props.data.price,
            unitPriceTypeId: props.data.unitPriceTypeId,
            maskedPrice: props.data.price.toString(),
            amount: props.data.amount,
            cost: props.data.cost,
            totalCost: props.data.totalCost,
        };

        this.quantityInputRef = React.createRef();
        this.productSelectRef = React.createRef();
        this.notesInputRef = React.createRef();
        this.priceInputRef = React.createRef();
        this.priceSelectRef = React.createRef();
        this.updateButtonRef = React.createRef();

        this.handleInputChanged = this.handleInputChanged.bind(this);
        this.handleQuantityChanged = this.handleQuantityChanged.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handlePriceChanged = this.handlePriceChanged.bind(this);
        this.handleQuantityOrPriceChanged =
            this.handleQuantityOrPriceChanged.bind(this);
        this.handleNotesChanged = this.handleNotesChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePriceKeyDown = this.handlePriceKeyDown.bind(this);
    }

    public render() {
        const numberMask = createNumberMask({
            allowDecimal: true,
            allowZeroFractionPadding: true,
        });

        return (
            <>
                <td>
                    <input
                        type="number"
                        step="any"
                        name="quantity"
                        className="form-control"
                        onChange={this.handleQuantityChanged}
                        value={this.state.maskedQuantity}
                    />
                </td>
                <td>
                    <input
                        type="text"
                        name="unitMeasurement"
                        className="form-control"
                        onChange={this.handleInputChanged}
                        value={this.state.unitMeasurement}
                    />
                </td>
                <td>
                    {this.state.productId ? (
                        <ProductSelect
                            onItemSelect={this.handleProductSelect}
                            ref={this.productSelectRef}
                            value={{
                                value: this.state.productId!,
                                label: this.state.productName!,
                            }}
                        />
                    ) : (
                        <ProductSelect
                            onItemSelect={this.handleProductSelect}
                            ref={this.productSelectRef}
                        />
                    )}
                </td>
                <td>
                    <textarea
                        name="notes"
                        className="form-control"
                        onChange={this.handleNotesChanged}
                        value={this.state.notes}
                        ref={this.notesInputRef}
                    />
                </td>
                <td>
                    <select
                        className="form-control"
                        name="unitPriceTypeId"
                        onChange={this.handleInputChanged}
                        value={this.state.unitPriceTypeId}
                    >
                        <option value="">--</option>
                        <option value={UnitPriceType.TBD}>TBD</option>
                        <option value={UnitPriceType.NC}>NC</option>
                        <option value={UnitPriceType.NotAvail}>Not Avail</option>
                        <option value={UnitPriceType.NoBid}>No Bid</option>
                        <option value={UnitPriceType.NotMade}>Not Made</option>
                        <option value={UnitPriceType.Note}>Note</option>
                    </select>
                </td>
                <td>
                    <input
                        type="number"
                        name="price"
                        className="form-control"
                        autoComplete="off"
                        onChange={this.handlePriceInputChanged}
                        onFocus={this.handlePriceFocus}
                        value={this.state.price !== undefined ? this.state.price : ''}
                    />
                </td>
                <td className="text-right">
                    {this.state.amount !== undefined &&
                        numeral(this.state.amount).format("$0,0.00")}
                </td>
                <td>
                    <button
                        type="button"
                        className="form-control btn btn-primary"
                        onClick={this.handleSubmit}
                        ref={this.updateButtonRef}
                    >
                        Update
                    </button>
                </td>
            </>
        );
    }

    public componentDidMount() {
        this.notesInputRef.current!.style.height = "0px";
        this.notesInputRef.current!.style.height =
            this.notesInputRef.current!.scrollHeight + "px";
    }

    private handleInputChanged(
        event: React.FormEvent<
            HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value,
        } as any);
    }

    private handleQuantityChanged(event: React.FormEvent<HTMLInputElement>) {
        const maskedValue = event.currentTarget.value;
        const value = parseFloat(maskedValue) || 0;

        this.setState({
            quantity: value,
            maskedQuantity: maskedValue,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handlePriceChanged(inputPrice: string) {
        const value = parseFloat(inputPrice) || 0;

        this.setState({
            price: value,
        });

        this.handleQuantityOrPriceChanged();
    }

    private handleQuantityOrPriceChanged() {
        this.setState((prevState) => ({
            amount: prevState.quantity * prevState.price,
        }));
    }

    //private async handleProductSelect(value: Option | null) {
    //    if (value === null) {
    //        this.setState({
    //            productId: undefined,
    //            unitMeasurement: undefined,
    //            productName: undefined,
    //        });
    //    } else {
    //        this.setState({
    //            productId: value!.value as number,
    //            unitMeasurement: value!.unitMeasurement as string | undefined,
    //            productName: value!.label as string,
    //        });
    //    }
    //}

    private async handleProductSelect(value: Option | null) {

        if (!value) {
            this.setState({
                productId: undefined,
                unitMeasurement: undefined,
                productName: undefined,
            });
            return;
        }

        // Set the parent info in case it's not a kit
        const updatedState = {
            productId: value!.value as number,
            unitMeasurement: value!.unitMeasurement as string | undefined,
            productName: value!.label as string,
        };

        // If it's a kit with children, send them to the parent
        if (value.kitChildren && Array.isArray(value.kitChildren)) {
            // Use the user-entered quantity to multiply with each kit child's quantity
            const userEnteredQuantity = this.state.quantity || 1;
            const kitChildren = value.kitChildren.map((child: any) => {
                const childQuantity = (child.quantity || 1) * userEnteredQuantity;
                return {
                    productId: child.id,
                    productName: child.name,
                    unitMeasurement: child.unitMeasurement,
                    quantity: childQuantity,
                    price: child.price || 0,
                    amount: childQuantity * (child.price || 0),
                    isKitChild: true,
                    parentProductId: value.value,
                };
            });

            this.props.onKitChildrenAdd?.(kitChildren); // new callback

            return;

        } else {
            this.setState(updatedState);
        }
    }



    private handleNotesChanged(event: React.FormEvent<HTMLTextAreaElement>) {
        this.handleInputChanged(event);
        event.currentTarget.style.height = "0px";
        event.currentTarget.style.height = event.currentTarget.scrollHeight + "px";
    }

    private handlePriceInputChanged = (event: React.FormEvent<HTMLInputElement>) => {
        const inputValue = event.currentTarget.value;

        if (inputValue === '') {
            this.setState({ price: 0, amount: 0 });
            return;
        }

        const numericValue = parseFloat(inputValue.replace(/[^0-9.]/g, ''));

        if (!isNaN(numericValue)) {
            const roundedValue = Math.round(numericValue * 100) / 100;

            this.setState({ price: roundedValue }, () => {
                this.handleQuantityOrPriceChanged();
            });
        }
    };

    private handlePriceFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.select();
    };

    private handlePriceKeyDown(event: React.KeyboardEvent<HTMLTableCellElement>) {
        if (event.key === "Tab" && !event.shiftKey) {
            event.preventDefault();
            this.updateButtonRef.current?.focus();
        }
    }

    private handleSubmit() {
        let data = {
            productId: this.state.productId,
            quantity: this.state.quantity,
            unitMeasurement: this.state.unitMeasurement,
            productName: this.state.productName,
            notes: this.state.notes,
            unitPriceTypeId: this.state.unitPriceTypeId,
            price: this.state.price,
            amount: this.state.amount,
        };

        this.props.onSubmit(data);
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/Step3.tsx